module.exports = __webpack_public_path__ + "img/bus-c.47e65fcb.png";